import { AGENT_URL } from '@/config/env'
import { fetchJsonWithAuth, mutateJsonWithAuth } from '@/lib/api'
import type {
  CobaltProvider,
  CobaltProviderDirectory,
  CobaltProviderRefresh,
} from './types'

const base = `${AGENT_URL}/connections/ecw-cobalt/providers`

export function fetchCobaltProviders(token: string, signal?: AbortSignal) {
  return fetchJsonWithAuth<CobaltProviderDirectory>({
    token,
    url: base,
    signal,
    errorMessage: 'Could not load Cobalt providers',
  })
}

export function refreshCobaltProviders(token: string) {
  return mutateJsonWithAuth<CobaltProviderRefresh>({
    token,
    url: `${base}/refresh`,
    method: 'POST',
    errorMessage: 'Could not start provider discovery',
  })
}

export function fetchCobaltProviderRefresh(
  token: string,
  jobId: string,
  signal?: AbortSignal
) {
  return fetchJsonWithAuth<CobaltProviderRefresh>({
    token,
    url: `${base}/refresh/${encodeURIComponent(jobId)}`,
    signal,
    errorMessage: 'Could not check provider discovery',
  })
}

export function updateCobaltProvider(
  token: string,
  id: string,
  status: CobaltProvider['status']
) {
  return mutateJsonWithAuth<{ status: CobaltProvider['status'] }>({
    token,
    url: `${base}/${encodeURIComponent(id)}`,
    method: 'PATCH',
    body: { status },
    errorMessage: 'Could not update provider',
  })
}
